<template>
<div class="amount-displayer">
  <div class="amount-displayer__title">
    {{ $t('paymentList.amountToPay') }}
  </div>
  <div class="amount-displayer__amount">
    {{symbol}}
    {{amount|currency}}
  </div>
</div>
</template>

<script>
import { getSymbol, fen2yuan } from '@/utils/currency'
import { get } from 'lodash-es'

import { types } from '@hll/cashier-kit'
import { mapGetters } from 'vuex'

export default {
  name: 'AmountDisplayer',
  computed: {
    ...mapGetters([types.ORDER_INFO]),
    symbol () {
      return getSymbol(get(this[types.ORDER_INFO], 'orderInfo.hcurrency'))
    },
    amount () {
      return fen2yuan(get(this[types.ORDER_INFO], 'orderInfo.amount_fen'), 0)
    }
  }
}
</script>

<style scoped lang="scss">
.amount-displayer{
  text-align: center;
  &__title{
    color: #737373;
    font-size: 12px;
    font-weight: bold;
  }
  &__amount{
    color: #303030;
    font-size: 32px;
    font-weight: bold;
  }
}
</style>
